export type AcceptMyInviteQueryPayload = { orgId: string };

export type AcceptMyInviteResponse = { responseCode: number };

export type ResponseMeta = { response: { status: number } };

export enum HTTP_RESPONSE_STATUS {
  CREATED = 201,
  BAD_REQUEST = 400,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
}

type AcceptMyInvitesError = {
  responseCode: number;
};

export const isAcceptMyInvitesError = (
  error: unknown,
): error is AcceptMyInvitesError => {
  return typeof error === 'object' && error !== null && 'responseCode' in error;
};
